import React from 'react';
import { InputAdornment } from 'uiKit/atoms/InputAdornment/InputAdornment';
import { InputBase } from 'uiKit/atoms/InputBase/InputBase';
import { Paper } from 'uiKit/atoms/Paper/Paper';
import { SearchOutlined } from 'uiKit/atoms/SearchOutlined/SearchOutlined';
import PropTypes from 'prop-types';
import styles from './Search.module.scss';

const Search = ({ value, setValue, onSubmit, placeholder, maxLength }) => {
  const changeHandler = event => {
    setValue(event.target.value);
  };

  const submitHandler = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onSubmit();
    }
  };

  if (maxLength && value.length > maxLength) {
    setValue(value.slice(0, maxLength));
  }

  return (
    <Paper className={styles.wrapper}>
      <InputBase
        data-testid="input"
        className={styles.search}
        startAdornment={
          <InputAdornment position="start">
            <SearchOutlined />
          </InputAdornment>
        }
        value={value}
        placeholder={placeholder}
        onKeyPress={submitHandler}
        onChange={changeHandler}
      />
    </Paper>
  );
};

Search.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
};

export default Search;
